/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DistributionChannelRequest
 */
export interface DistributionChannelRequest {
    /**
     * 
     * @type {string}
     * @memberof DistributionChannelRequest
     */
    label?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DistributionChannelRequest
     */
    showNonEffective?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DistributionChannelRequest
     */
    showDeleted?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DistributionChannelRequest
     */
    offset?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DistributionChannelRequest
     */
    limit?: number | null;
}

export function DistributionChannelRequestFromJSON(json: any): DistributionChannelRequest {
    return DistributionChannelRequestFromJSONTyped(json, false);
}

export function DistributionChannelRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): DistributionChannelRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'label': !exists(json, 'label') ? undefined : json['label'],
        'showNonEffective': !exists(json, 'showNonEffective') ? undefined : json['showNonEffective'],
        'showDeleted': !exists(json, 'showDeleted') ? undefined : json['showDeleted'],
        'offset': !exists(json, 'offset') ? undefined : json['offset'],
        'limit': !exists(json, 'limit') ? undefined : json['limit'],
    };
}

export function DistributionChannelRequestToJSON(value?: DistributionChannelRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'label': value.label,
        'showNonEffective': value.showNonEffective,
        'showDeleted': value.showDeleted,
        'offset': value.offset,
        'limit': value.limit,
    };
}


